<template>
  <!-- 表单主体容器 -->
  <div class="form-container">
    <!-- 页面标题 -->
    <div class="price-report-wrapper">
      <div class="price-report-card">
        <!-- 顶部操作栏 -->
        <!-- 顶部操作栏 -->
        <div class="operation-header">
          <div class="header-left">
            <el-button
              type="text"
              icon="el-icon-arrow-left"
              @click="goBack"
              class="back-btn"
            >
              返回
            </el-button>
            <h2 class="title">
              <i class="el-icon-notebook-2"></i>
              资格申报记录
            </h2>
          </div>
          <div class="action-buttons">
            <el-button
              type="primary"
              @click="createPerformance"
              class="action-btn primary-btn"
            >
              资格申报
            </el-button>
          </div>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-container">
          <el-table
            ref="recordsTable"
            :data="reportRecords"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{
              background: '#f8fafc',
              color: '#606266',
              fontWeight: '600',
            }"
            :cell-style="{ padding: '16px 0' }"
            empty-text="暂无上报记录"
            class="elegant-table"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="企业全称"
              width="100"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="companyType"
              label="企业性质"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="creditCode"
              label="统一社会信用代码"
              width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="annualTurnover"
              label="年营业额（万元）"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="assetLiabilityRatio"
              label="资产负债率（%）"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="businessScope"
              label="再生资源经营范围（主营）"
              width="240"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="environmentalCode"
              label="环保合规证明编号"
              width="240"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auditStatus"
              label="审核状态"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.auditStatus === 0
                    ? '待审核'
                    : scope.row.auditStatus === 1
                      ? '通过'
                      : '驳回'
                }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope)"
                  class="detail-btn"
                >
                  <i class="el-icon-document"></i> 查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="资格申报"
      :visible.sync="showDialog"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="performance-upload-page">
        <!-- 绩效表单 -->
        <el-form
          ref="applyFormRef"
          :model="applyForm"
          :rules="formRules"
          label-width="220px"
          class="apply-form"
        >
          <el-form-item label="企业全称" prop="companyName">
            <el-input
              v-model="applyForm.companyName"
              placeholder="请输入企业全称"
              maxlength="100"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 企业性质 -->
          <el-form-item label="企业性质" prop="companyType">
            <el-select
              v-model="applyForm.companyType"
              placeholder="请选择企业性质"
              style="width: 70%"
              :disabled="isDisabled"
            >
              <el-option label="有限责任公司" value="有限责任公司" />
              <el-option label="股份有限公司" value="股份有限公司" />
              <el-option label="个体工商户" value="个体工商户" />
              <el-option label="国有企业" value="国有企业" />
              <el-option label="集体企业" value="集体企业" />
            </el-select>
          </el-form-item>

          <!-- 统一社会信用代码 -->
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input
              v-model="applyForm.creditCode"
              placeholder="请输入统一社会信用代码"
              maxlength="18"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 年营业额（万元） -->
          <el-form-item label="年营业额（万元）" prop="annualTurnover">
            <el-input
              v-model="applyForm.annualTurnover"
              placeholder="请输入年营业额"
              type="number"
              precision="0"
              min="0"
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 资产负债率（%） -->
          <el-form-item label="资产负债率（%）" prop="assetLiabilityRatio">
            <el-input
              v-model="applyForm.assetLiabilityRatio"
              placeholder="请输入资产负债率"
              type="number"
              precision="1"
              min="0"
              max="100"
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 再生资源经营范围（主营） -->
          <el-form-item label="再生资源经营范围（主营）" prop="businessScope">
            <el-input
              v-model="applyForm.businessScope"
              placeholder="请输入再生资源经营范围"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 近两年环保合规证明编号（选填） -->
          <el-form-item
            label="近两年环保合规证明编号（选填）"
            prop="environmentalCode"
          >
            <el-input
              v-model="applyForm.environmentalCode"
              placeholder="请输入环保合规证明编号"
              maxlength="50"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>

          <el-form-item
            label="驳回原因"
            prop="auditRemark"
            v-show="isDisabled && applyForm.auditStatus == 2"
          >
            <el-input
              v-model="applyForm.auditRemark"
              type="textarea"
              :rows="3"
              placeholder="请输入驳回原因（必填）"
              maxlength="500"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item class="submit-btn-group" v-show="!isDisabled">
            <el-button
              type="primary"
              size="large"
              @click="submitForm"
              class="submit-btn"
            >
              <i class="el-icon-check"></i>
              提交申报资格
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createQualification,
  getQualificationApplication,
} from '@/API/apply/apply.js';
export default {
  name: 'QualificationApply',
  data() {
    // 自定义校验：统一社会信用代码（18位）
    const validateCreditCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入统一社会信用代码'));
      } else if (
        !/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value)
      ) {
        callback(new Error('请输入正确的统一社会信用代码'));
      } else {
        callback();
      }
    };
    return {
      // 表单数据（初始值与截图一致）
      applyForm: {
        companyName: '', // 默认值（截图示例）
        companyType: '', // 默认值
        creditCode: '', // 默认值
        annualTurnover: '', // 默认值
        assetLiabilityRatio: '', // 默认值
        businessScope: '', // 默认值
        environmentalCode: '', // 默认值
        auditRemark: '',
      },
      showDialog: false,
      reportRecords: [],
      isDisabled: false,
      // 表单校验规则
      // 表单校验规则
      formRules: {
        companyName: [
          { required: true, message: '请输入企业全称', trigger: 'blur' },
        ],
        companyType: [
          { required: true, message: '请选择企业性质', trigger: 'change' },
        ],
        creditCode: [
          { required: true, validator: validateCreditCode, trigger: 'blur' },
        ],
        annualTurnover: [
          { required: true, message: '请输入年营业额', trigger: 'blur' },
          { type: 'string', message: '年营业额必须为数字', trigger: 'blur' },
        ],
        assetLiabilityRatio: [
          { required: true, message: '请输入资产负债率', trigger: 'blur' },
          { type: 'string', message: '资产负债率必须为数字', trigger: 'blur' },
          { max: 100, message: '资产负债率不能超过100%', trigger: 'blur' },
        ],
        businessScope: [
          {
            required: true,
            message: '请输入再生资源经营范围',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    getData() {
      getQualificationApplication().then((res) => {
        if (res.code === 200) {
          this.reportRecords = res.data.records;
        }
      });
    },
    createPerformance() {
      this.showDialog = true;
      this.isDisabled = false;
      this.applyForm = {
        companyName: '', // 默认值（截图示例）
        companyType: '', // 默认值
        creditCode: '', // 默认值
        annualTurnover: '', // 默认值
        assetLiabilityRatio: '', // 默认值
        businessScope: '', // 默认值
        environmentalCode: '', // 默认值
      };
    },
    handleClick(scope) {
      this.showDialog = true;
      this.applyForm = scope.row;
      this.isDisabled = true;
    },
    // 提交表单
    submitForm() {
      this.$refs.applyFormRef.validate((valid) => {
        if (valid) {
          // 表单校验通过，调用接口提交
          createQualification(this.applyForm)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('申报资格提交成功！');
                this.showDialog = false;
                this.getData();
                // 提交成功后重置表单（可选）
                this.$refs.applyFormRef.resetFields();
                // this.$refs.applyFormRef.clearValidate();
              } else {
                this.$message.error(res.message || '提交失败，请重试');
              }
            })
            .catch((err) => {
              this.$message.error('网络异常，提交失败');
              console.error('提交失败：', err);
            });
        } else {
          this.$message.warning('请完善必填项后提交');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.performance-upload-page {
  width: 100%;
  background: #f5f7fa;
  padding: 30px 0;

  //表单样式 .apply-form {
  ::v-deep .el-form-item {
    margin-bottom: 25px;
    .el-form-item__error {
      padding-left: 220px;
      padding-top: 4px;
      font-size: 12px;
      line-height: 1.5;
      color: #f56c6c;
    }

    .el-input,
    .el-select,
    .el-textarea {
      width: 70%;
      max-width: 500px;
      border-radius: 4px;
    }

    .el-textarea {
      resize: none;
    }
  }

  // 提交按钮组
  .submit-btn-group {
    margin-top: 40px;
    text-align: center;

    .submit-btn {
      width: 280px;
      height: 48px;
      font-size: 16px;
      background: #1abe6b;
      border: none;
      border-radius: 4px;

      &:hover {
        background: #15ad61;
      }
    }
  }

  // 适配小屏幕
  @media (max-width: 768px) {
    .qualification-apply {
      padding: 15px;
      margin: 10px;
    }

    .page-title {
      font-size: 18px;
    }

    .submit-btn {
      width: 100% !important;
    }
    .el-form-item__error {
      padding-left: 80px !important;
    }
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}

// 移动端适配
@media (max-width: 768px) {
  .performance-upload-page {
    padding: 15px;

    .form-container {
      padding: 15px;

      .form-header {
        h2 {
          font-size: 16px;
        }
      }

      .performance-form {
        .el-form-item {
          label-width: 80px !important;
        }
      }
    }
  }
}
.price-report-wrapper {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 60px);
  padding: 24px;
  background-color: #f5f7fa;

  .price-report-card {
    width: 100%;
    max-width: 1200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 24px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }

  // ... existing code ...
  .operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;

      .back-btn {
        font-size: 14px;
        color: #606266;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          color: #409eff;
          background: rgba(64, 158, 255, 0.1);
        }

        i {
          margin-right: 4px;
          font-size: 16px;
        }
      }
    }

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
        color: #409eff;
        font-size: 24px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 10px 16px;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
        }
      }

      .primary-btn {
        background: linear-gradient(135deg, #409eff, #66b1ff);
        border: none;
      }
    }
  }
  // ... existing code ...

  .table-container {
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #ebeef5;

    .elegant-table {
      ::v-deep .el-table__header-wrapper {
        th {
          font-weight: 600;
          letter-spacing: 0.5px;
        }
      }

      ::v-deep .el-table__body-wrapper {
        .el-table__row {
          transition: background-color 0.3s;

          &:hover {
            background-color: #f8fafc;
          }

          .cell {
            .company-name {
              font-weight: 500;
              color: #303133;
            }
          }
        }
      }

      .detail-btn {
        color: #409eff;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        i {
          margin-right: 6px;
        }

        &:hover {
          background: rgba(64, 158, 255, 0.1);
          color: #66b1ff;
        }
      }

      ::v-deep .el-table__empty-block {
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-table__empty-text {
          color: #909399;
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .price-report-wrapper {
    padding: 16px;

    .price-report-card {
      padding: 16px;
    }

    .operation-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .action-buttons {
        width: 100%;
        flex-wrap: wrap;
      }
    }

    .table-container {
      overflow-x: auto;
    }
  }
}
</style>
